import styled from 'styled-components';

import { styledLayout } from '@pkg/primitives';

import { tokens } from './tokens';

///
/// SearchInput

export const EmojiPickerWrapper = styled.div`
    margin-right: ${tokens.offset}px;
`;

export const SearchLoadingWrapper = styled.div`
    padding: 1em;
    align-items: center;
    justify-content: center;
    display: flex;
    width: 100%;

    svg {
        max-width: 20px;
    }
`;

export const SearchResultWrapper = styled.div`
    padding: 1em;
    border-radius: 1.25em;
    background: ${({ theme }) => theme.shades.white[5]};
    backdrop-filter: blur(2.6em);
    overflow-y: auto;
    outline: 0;
    // Higher than groups home page content + primary yat selector
    z-index: 11;

    // Scroll styles

    --yat_scrollbar-thumb-color: ${({ theme }) => theme.colors.purple};

    ${styledLayout.scrollbar({
        thumbColor: 'var(--yat_scrollbar-thumb-color)',
        trackColor: 'transparent',
    })};

    box-shadow: 3px 7px 14px 0px #0000004a;

    overflow-y: auto;
    overscroll-behavior-y: contain;
`;

///
/// SearchInputMobile

export const StyledSearchInputMobile = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    gap: 0.5em;
    padding: 8px 16px;
    width: 100%;
    height: 78px;
    font-size: 20px;
    font-weight: 700;
    color: white;
    border-bottom: 1px solid ${({ theme }) => theme.shades.white[10]};

    > input[type='search'] {
        width: 100%;
        font-size: inherit;
        font-weight: inherit;
    }
`;

export const IconWrapper = styled.div`
    width: 2em;
    line-height: 1;
    flex-shrink: 0;
    color: ${({ theme }) => theme.shades.white[20]};
`;

export const CloseWrapper = styled.button<{ $visible: boolean }>`
    visibility: ${({ $visible }) => ($visible ? 'visible' : 'hidden')};
    width: 2em;
    height: 2em;
    border: none;
    outline: 0;
    background-color: ${({ theme }) => theme.colors.transparent};
    border-radius: 999px;
    transition-property: background-color, opacity;
    transition-duration: ${({ theme }) => theme.transitions.speeds.fast}s;
    transition-timing-function: ${({ theme }) => theme.transitions.easesCss.cubic};
    color: ${({ theme }) => theme.colors.white};
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    &[disabled],
    &[aria-pressed] {
        opacity: 0.8;
    }

    &:hover {
        background-color: ${({ theme }) => theme.shades.white[15]};
    }

    &:active {
        background-color: ${({ theme }) => theme.shades.white[10]};
    }

    svg {
        width: 100%;
        height: 100%;
    }
`;

export const SearchResultWrapperMobile = styled.div`
    height: calc(100vh - 134px);
    overflow-y: auto;
    padding: 1em;
`;
